<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form action="" class="form-box" @submit.prevent="validateForm" novalidate>
              <!-- <FormInput
                  name="Username"
                  type="text"
                  label="Username"
                  v-model="values.Username"
                  placeholder="Username"
                  :require-field="true"
                  @validate="validate"
                  :disabled="true"
                  :error="errors.Username"
                /> -->
              <FormInput name="OldPassword" type="password" label="รหัสผ่านเก่า" v-model="values.OldPassword"
                placeholder="รหัสผ่านเก่า" :require-field="true" @validate="validate" :error="errors.OldPassword"
                formGroupClass="form-group" />
              <FormInput name="Password" type="password" label="รหัสผ่าน" v-model="values.Password" placeholder="รหัสผ่าน"
                :require-field="true" @validate="validate" :error="errors.Password" formGroupClass="form-group" />
              <FormInput name="ConfirmPassword" type="password" label="ยืนยันรหัสผ่าน" v-model="values.ConfirmPassword"
                placeholder="ยืนยันรหัสผ่าน" :require-field="true" @validate="validate" :error="errors.ConfirmPassword"
                formGroupClass="form-group" />
              <div class="mt-4">
                <button type="submit" class="btn btn-primary mr-1" :disabled="IsSubmit">
                  เปลี่ยนรหัสผ่าน
                  <div v-show="IsSubmit" class="spinner-border spinner-border-sm ml-2" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </button>
                <button @click="$router.go(-1)" class="btn btn-secondary">ย้อนกลับ</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>

import Layout from '@/components/layouts/main'
import PageHeader from '@/components/page-header'


/**
 * Customers component
 */
export default {
  page: {
    title: 'Change Password',
    meta: [{ name: 'admin-change-password' }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    var yup = this.yup
    return {
      title: 'เปลี่ยนรหัสผ่าน Admin',
      items: [
        {
          text: 'SKLife',
          to: { name: 'home' }
        },
        {
          text: 'Change Password',
          active: true,
        },
      ],
      admin: {},
      refId: '',
      IsSubmit: false,
      changePassword: false,
      VUE_APP_OFFICEAPI_URL: process.env.VUE_APP_OFFICEAPI_URL,
      PrefixDatas: [
        { id: 1, value: 'นาย' },
        { id: 2, value: 'นาง' },
        { id: 3, value: 'นางสาว' },
      ],
      ActiveDatas: [
        { id: true, value: 'ใช้งานได้' },
        { id: false, value: 'ใช้งานไม่ได้' },
      ],
      RoleDatas: [
        { id: 1, value: 'Admin' },
        { id: 2, value: 'Staff' },
      ],
      values: {
        OldPassword: '',
        Username: "",
        PrefixId: "",
        Firstname: "",
        Lastname: "",
        Email: "",
        Phone: "",
        Password: "",
        ConfirmPassword: "",
        Role: "",
        Active: "",
      },
      errors: {
        OldPassword: '',
        Username: "",
        PrefixId: "",
        Firstname: "",
        Lastname: "",
        Email: "",
        Phone: "",
        Password: "",
        ConfirmPassword: "",
        Role: "",
        Active: "",
      },
      FormSchema: yup.object().shape({
        OldPassword: yup.string().required(),
        Password: yup.string().min(8).required('กรุณากรอกรหัสผ่าน'),
        ConfirmPassword: yup.string()
          .required('กรุณายืนยันรหัสผ่านอีกครั้ง')
          .oneOf([yup.ref("Password")], "รหัสผ่านไม่เหมือนกัน"),
      }),
    }
  },
  async created() {
    let self = this;
    if (this.$store.state.Admin.RefId) {
      this.refId = this.$store.state.Admin.RefId;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` }
      };
      this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/admin/' + this.refId, config)
        .then(function (res) {
          if (res.status == 200) {
            res.data.Password = '';
            self.values = res.data;
          } else {
            self.$swal('เกิดข้อผิดพลาด');
          }
        })
        .catch(function (error) {
          self.$swal('เกิดข้อผิดพลาด');
        });
    }
  },
  methods: {
    validateForm() {
      this.FormSchema
        .validate(this.values, { abortEarly: false })
        .then(() => {
          this.sendData(this.values);
        })
        .catch(err => {
          console.log(err)
          err.inner.forEach(error => {
            this.errors = { ...this.errors, [error.path]: error.message };
          });
        });
    },
    validate(field) {
      this.FormSchema
        .validateAt(field, this.values)
        .then(() => {
          this.errors[field] = "";
        })
        .catch(err => {
          this.errors[err.path] = err.message;
        });
    },
    sendData(values) {
      console.log('1111')
      let self = this;
      this.IsSubmit = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` }
      };

      this.axios.put(process.env.VUE_APP_OFFICEAPI_URL + '/api/admin/changepassword', values, config)
        .then(function (res) {
          console.log(res)
          if (res.status == 200) {
            self.$swal({ title: 'เปลี่ยนรหัสผ่าน', text: 'เปลี่ยนรหัสผ่านสำเร็จ กรุณาเข้าสู่ระบบอีกครั้ง', icon: 'success' })
              .then((result) => {
                self.$store.commit('clearAuth')
                self.$router.push({ name: 'login' })
              })
          } else {
            self.$swal('เกิดข้อผิดพลาด');
          }
          self.IsSubmit = false;
        })
        .catch(function (error) {
          self.$swal('เกิดข้อผิดพลาด');
          self.IsSubmit = false;
          console.log(error);
        });

    },
  },
}
</script>

